import React from 'react';
import PatientBranch from './PatientBranch';

const EditPatientBranch = () => {
    return <PatientBranch />;
};

export default EditPatientBranch;
